<div class="relative flex min-h-full overflow-hidden">
  <div class="flex h-full w-full flex-col gap-5 py-4" [ngClass]="{ 'max-w-[calc(100%_-_420px)]': sidebarVisible() }">
    <div
      class="flex items-center gap-x-2 pl-10"
      [ngClass]="{
        'pr-24': !sidebarVisible(),
        'pr-14': sidebarVisible()
      }"
    >
      <div class="flex items-center gap-2">
        <button class="btn-secondary" [disabled]="appointmentIsEdited()" (click)="onTodayClick()">
          {{ 'schedule_calendar_today' | translate }}
        </button>
        <lib-date-picker
          [date]="date()"
          [dateFormat]="'EEE, MMM dd, yyyy'"
          (dateChange)="onDateChange($event)"
          [ngClass]="{
            'pointer-events-none !text-text-light': appointmentIsEdited()
          }"
        />
      </div>
      <div class="ml-auto flex items-center gap-2">
        <button class="flex h-5 w-5 items-center justify-center" (click)="onScheduleLegendClick()" type="button" title="Schedule Legend">
          <svg-icon key="px-16-info" class="h-5 w-5 text-primary-blue" />
        </button>
        @if (!isEaglesoftPms()) {
          <button class="btn-primary" [disabled]="appointmentIsEdited()" (click)="onNewAppointmentWithButton()">
            {{ 'schedule_calendar_new' | translate }}
          </button>
        }
      </div>
      @if (operatoriesDropdownElements().length > 0) {
        <lib-schedule-filter
          class="overflow-hidden"
          [isShowcase]="isShowcase()"
          [operatories]="operatoriesDropdownElements()"
          [selectedOperatories]="dropdownSelectedOperatories()"
          [showTentative]="showTentative()"
          (selectOperatory)="onOperatoryFilterChange($event)"
          (filterTentative)="onTentativeFilterChange($event)"
          (showCompactView)="onCompactViewChange($event)"
          (hidePatientName)="onHidePatientNameChange($event)"
        >
          <button class="flex h-10 w-10 items-center justify-center rounded-2xl bg-background-white text-primary-blue" libDropdownTrigger>
            <svg-icon key="px-24-filter" size="md" />
          </button>
        </lib-schedule-filter>
      } @else {
        <div class="h-[40px] w-[40px]"></div>
      }
    </div>
    <lib-schedule-calendar
      [isShowcase]="isShowcase()"
      [isToday]="isToday()"
      [selectedAppointmentId]="selectedAppointment()?.id"
      [selectedEventId]="selectedEvent()?.id"
      [operatories]="selectedOperatories()"
      [myDay]="myDay()"
      [isScheduleLoadingSignal]="isScheduleLoadingSignal"
      [isCompactViewSignal]="isCompactView"
[hidePatientNameSignal]="hidePatientName"
      [showTentativeSignal]="showTentative"
      [areTreatmentsLoadedSignal]="areTreatmentsLoaded()"
      (appointmentSelect)="onAppointmentSelect($event)"
      (appointmentClick)="onAppointmentClick()"
      (appointmentDoubleClick)="onAppointmentDoubleClick()"
      (eventClick)="onEventClick($event)"
      (newAppointment)="onNewAppointmentFromCalendar($event)"
    />
  </div>
  <lib-right-side-bar
    [activePage]="setActivePage()"
    [rightSideBarVisible]="sidebarVisible()"
    (rightSideBarVisibilityChange)="onVisibilityChange($event)"
  ></lib-right-side-bar>
</div>
<router-outlet></router-outlet>
